import { render, staticRenderFns } from "./PartPopupArchive.vue?vue&type=template&id=e3bb703c&scoped=true&"
import script from "./PartPopupArchive.vue?vue&type=script&lang=js&"
export * from "./PartPopupArchive.vue?vue&type=script&lang=js&"
import style0 from "./PartPopupArchive.vue?vue&type=style&index=0&id=e3bb703c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3bb703c",
  null
  
)

export default component.exports